import { axiosV2 } from 'interceptors/axios';
import { store } from 'redux/store';
import { dispatchError } from 'utils/dispatchError';
import { decryptResponse } from 'utils/token';

type GetSocietySharesProps = {
  societyId: string;
  fields?: string;
  items?: number;
};

export const getSocietyShares = async ({
  societyId,
  fields = '',
  items = 100,
}: GetSocietySharesProps) => {
  const query = { params: { societyId, fields, items } };

  try {
    const { data } = await axiosV2.get('/shares/society', query);

    const decodedData = await decryptResponse(data);

    return decodedData;
  } catch (error) {
    dispatchError(error, store.dispatch);
  }
};
